import { render, staticRenderFns } from "./animation-dialog.vue?vue&type=template&id=4bba123c&scoped=true"
import script from "./animation-dialog.vue?vue&type=script&lang=js"
export * from "./animation-dialog.vue?vue&type=script&lang=js"
import style0 from "./animation-dialog.vue?vue&type=style&index=0&id=4bba123c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba123c",
  null
  
)

export default component.exports